import {
  Button,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { fetchRencanaKontrol } from "../../../redux/actions/history";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { truncateText } from "../../../helpers/common/utility";
import { ChevronRight } from "@mui/icons-material";
import ActionDialog from "../../../components/ActionDialog";
import Lotties from "../../../components/Lotties";
import WavingHands from "../../../assets/lottie/waving_hands.json";

type Props = {
  actFetchRencanaKontrol: ({ rkun_id }: any) => void;
  stateRencanaKontrol: any;
};

const RencanaKontrol = (props: Props) => {
  const { actFetchRencanaKontrol, stateRencanaKontrol } = props;
  const { id, ps_mrn } = useParams();
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    actFetchRencanaKontrol({ rkun_id: id, onUnauth: () => setOpen(true) });
    return () => {};
  }, []);

  return (
    <>
      <ActionDialog open={open} setOpen={(val: boolean) => setOpen(val)}>
        <Stack spacing={2}>
          <Lotties file={WavingHands} loop />
          <Typography variant="body1" align="center">
            Silahkan login terlebih dulu
          </Typography>
          <Button
            variant="outlined"
            onClick={() =>
              navigate("/login", {
                state: { from: location },
              })
            }
          >
            Login
          </Button>
        </Stack>
      </ActionDialog>
      <Stack spacing={1}>
        {stateRencanaKontrol.length == 0 && (
          <Paper
            sx={{
              padding: "16px 12px",
              borderRadius: "12px !important",
            }}
            elevation={0}
          >
            <Typography variant="body2" align="center">
              Tidak ada rencana kontrol
            </Typography>
          </Paper>
        )}
        {stateRencanaKontrol.map((item: any) => {
          return (
            <>
              <Paper
                sx={{
                  padding: "16px 12px",
                  borderRadius: "12px !important",
                }}
                elevation={0}
              >
                <Grid
                  container
                  justifyContent={"space-between"}
                  alignItems="center"
                >
                  <Grid item xs={6}>
                    <Typography variant="subtitle2">
                      {item.layanan.name}
                    </Typography>
                    {item.dokter && (
                      <>
                        <Typography variant="body1">
                          {truncateText(item.dokter?.name, 22)} |{" "}
                          {item.rencana ? item.rencana.tanggal : "-"}
                        </Typography>
                      </>
                    )}
                  </Grid>
                  <Grid item>
                    {item.is_reserved && (
                      <IconButton
                        size="small"
                        onClick={() =>
                          navigate(`/antrian/${item.rencana.id}/${ps_mrn}`)
                        }
                      >
                        <ChevronRight />
                      </IconButton>
                    )}
                  </Grid>
                </Grid>
                {!item.is_reserved && (
                  <>
                    <Typography
                      variant="body2"
                      sx={{
                        marginTop: "6px",
                      }}
                      color="red"
                    >
                      *daftar mandiri
                    </Typography>
                    <Typography variant="body2" color="red">
                      {!item.is_bpjs
                        ? "*memerlukan rujukan aktif dari puskes/klink"
                        : ""}
                    </Typography>
                  </>
                )}
              </Paper>
            </>
          );
        })}
      </Stack>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    stateRencanaKontrol: state.history.rencana_kontrol,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    actFetchRencanaKontrol: ({ rkun_id, onUnauth }: any) =>
      dispatch(fetchRencanaKontrol({ rkun_id, onUnauth })),
    // actGetAntrianPoli: (id: number) => dispatch(getAntrianPoli(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RencanaKontrol);
